import * as React from 'react';

interface VerticalBorderProps {
  style?: React.CSSProperties;
}

const verticalBorderStyle: React.CSSProperties = {
  marginTop: 18,
  marginBottom: 18,
  border: 0,
  width: '2px',
  backgroundColor: '#414141',
};

const VerticalBorder: React.SFC<VerticalBorderProps> = (props) => {
  return <hr style={{ ...verticalBorderStyle, ...props.style }} />;
};

export default VerticalBorder;
